var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneratedContentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02021 2.21277C8.8507 2.17208 8.66095 2.16672 8.00981 2.16672H6.16667C5.45285 2.16672 4.96761 2.16737 4.59253 2.19801C4.22719 2.22786 4.04035 2.28197 3.91002 2.34838C3.59641 2.50816 3.34144 2.76313 3.18166 3.07674C3.11525 3.20707 3.06114 3.3939 3.03129 3.75925C3.00065 4.13433 3 4.61957 3 5.33339V8.00005C3 8.46029 2.6269 8.83339 2.16667 8.83339C1.70643 8.83339 1.33333 8.46029 1.33333 8.00005L1.33333 5.29897C1.33332 4.62816 1.33331 4.07453 1.37016 3.62353C1.40843 3.15512 1.49057 2.72453 1.69664 2.32008C2.01622 1.69288 2.52616 1.18294 3.15336 0.863364C3.55781 0.657288 3.9884 0.575152 4.45681 0.536881C4.90781 0.500033 5.46144 0.500042 6.13225 0.500052L8.00981 0.500053C8.03848 0.500053 8.06678 0.500039 8.09471 0.500026C8.62388 0.499774 9.02371 0.499584 9.40928 0.592153C9.7494 0.673809 10.0746 0.80849 10.3728 0.991252C10.7109 1.19844 10.9935 1.4813 11.3675 1.85565C11.3872 1.87541 11.4072 1.89543 11.4275 1.9157L13.251 3.73923C13.2713 3.7595 13.2913 3.7795 13.3111 3.79924C13.6854 4.17324 13.9683 4.45582 14.1755 4.79392C14.3582 5.09217 14.4929 5.41731 14.5746 5.75744C14.6671 6.14301 14.6669 6.54284 14.6667 7.072C14.6667 7.09994 14.6667 7.12823 14.6667 7.15691V10.7011C14.6667 11.3719 14.6667 11.9256 14.6298 12.3766C14.5916 12.845 14.5094 13.2756 14.3034 13.68C13.9838 14.3072 13.4738 14.8172 12.8466 15.1367C12.4422 15.3428 12.0116 15.425 11.5432 15.4632C11.0922 15.5001 10.5386 15.5001 9.86777 15.5001H8.83333C8.3731 15.5001 8 15.127 8 14.6667C8 14.2065 8.3731 13.8334 8.83333 13.8334H9.83333C10.5471 13.8334 11.0324 13.8327 11.4075 13.8021C11.7728 13.7722 11.9597 13.7181 12.09 13.6517C12.4036 13.4919 12.6586 13.237 12.8183 12.9234C12.8848 12.793 12.9389 12.6062 12.9687 12.2409C12.9994 11.8658 13 11.3805 13 10.6667V7.15691C13 6.50577 12.9946 6.31602 12.9539 6.14651C12.9131 5.97645 12.8458 5.81388 12.7544 5.66476C12.6633 5.51612 12.5329 5.37816 12.0725 4.91774L10.249 3.09421C9.78856 2.63379 9.6506 2.5034 9.50196 2.41232C9.35284 2.32094 9.19027 2.2536 9.02021 2.21277Z",
    fill: "url(#paint0_linear_6317_6005)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83333 9.16672C4.04855 9.16672 4.23962 9.30443 4.30767 9.50861L5.06195 11.7714L7.32478 12.5257C7.52895 12.5938 7.66667 12.7848 7.66667 13.0001C7.66667 13.2153 7.52895 13.4063 7.32478 13.4744L5.06195 14.2287L4.30767 16.4915C4.23962 16.6957 4.04855 16.8334 3.83333 16.8334C3.61812 16.8334 3.42705 16.6957 3.35899 16.4915L2.60471 14.2287L0.341886 13.4744C0.137715 13.4063 0 13.2153 0 13.0001C0 12.7848 0.137715 12.5938 0.341886 12.5257L2.60472 11.7714L3.35899 9.50861C3.42705 9.30443 3.61812 9.16672 3.83333 9.16672Z",
    fill: "url(#paint1_linear_6317_6005)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.83333 1.33339C9.29357 1.33339 9.66667 1.70648 9.66667 2.16672V5.50005H13C13.4602 5.50005 13.8333 5.87315 13.8333 6.33339C13.8333 6.79362 13.4602 7.16672 13 7.16672H8.83333C8.3731 7.16672 8 6.79362 8 6.33339V2.16672C8 1.70648 8.3731 1.33339 8.83333 1.33339Z",
    fill: "url(#paint2_linear_6317_6005)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6317_6005",
    x1: 1.33301,
    y1: 1.33333,
    x2: 13.833,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3474E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07FF8F",
    stopOpacity: 0.53
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6317_6005",
    x1: 1.33301,
    y1: 1.33333,
    x2: 13.833,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3474E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07FF8F",
    stopOpacity: 0.53
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6317_6005",
    x1: 1.33301,
    y1: 1.33333,
    x2: 13.833,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3474E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07FF8F",
    stopOpacity: 0.53
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneratedContentIcon);
export default __webpack_public_path__ + "static/media/generated_content_icon.9e705827c7fc357f4a3b943b9d12c81a.svg";
export { ForwardRef as ReactComponent };